import { ReactElement } from 'react';

import DashboardVariantV2GiverContentInPreparationTabProvider from './Context';

import {
  DashboardVariantV2GiverContentTabContainer,
  DashboardVariantV2GiverContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2GiverContentInPreparationTabActions,
  DashboardVariantV2GiverContentInPreparationTabCurrentFilters,
  DashboardVariantV2GiverContentInPreparationTabDataTable,
} from './Components';

const DashboardVariantV2GiverContentInPreparationTab = (): ReactElement => (
  <DashboardVariantV2GiverContentInPreparationTabProvider>
    <DashboardVariantV2GiverContentTabContainer>
      <DashboardVariantV2GiverContentInPreparationTabActions />

      <DashboardVariantV2GiverContentInPreparationTabCurrentFilters />

      <DashboardVariantV2GiverContentWrapper>
        <DashboardVariantV2GiverContentInPreparationTabDataTable />
      </DashboardVariantV2GiverContentWrapper>
    </DashboardVariantV2GiverContentTabContainer>
  </DashboardVariantV2GiverContentInPreparationTabProvider>
);

export default DashboardVariantV2GiverContentInPreparationTab;
